import React from 'react';

import moment from 'moment';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { ActionTypeEnum, LogsItem, ShiftChange } from '../../types/interfaces';

interface ShiftsExpansionProps {
  rowData: LogsItem;
  addedItems: ShiftChange[];
  deletedItems: ShiftChange[];
  updatedItems: Array<{
    id: number;
    old: ShiftChange;
    new: ShiftChange;
  }>;
  actionLabel: string;
}

export const ShiftsExpansion: React.FC<ShiftsExpansionProps> = ({
  rowData,
  addedItems,
  deletedItems,
  updatedItems,
  actionLabel
}) => {
  return (
    <div>
      {(rowData.actionType === ActionTypeEnum.CREATE ||
        rowData.actionType === ActionTypeEnum.GENERATION) &&
        addedItems.length > 0 && (
        <div>
          <h5 className="pl-2">{actionLabel} смены</h5>
          <DataTable
            dataKey="id"
            value={addedItems}
            className="w-full mt-2 mb-4"
          >
            <Column
              columnKey="start"
              field="start"
              header="Дата"
              body={(row: ShiftChange) =>
                row.date
                  ? moment(row.date).format('DD.MM.YYYY')
                  : row.start
                    ? moment(row.start).format('DD.MM.YYYY')
                    : ''
              }
            />
            <Column
              columnKey="workdayStart"
              field="workdayStart"
              header="Начало смены"
            />
            <Column
              columnKey="workdayDuration"
              field="workdayDuration"
              header="Продолжительность"
            />
            <Column
              columnKey="breakDuration"
              field="breakDuration"
              header="Перерыв"
            />
          </DataTable>
        </div>
      )}

      {rowData.actionType === ActionTypeEnum.DELETE &&
        deletedItems.length > 0 && (
        <div>
          <h5 className="pl-2">{actionLabel} смены</h5>
          <DataTable
            dataKey="id"
            value={deletedItems}
            className="w-full mt-2 mb-4"
          >
            <Column
              columnKey="start"
              field="start"
              header="Дата"
              body={(row: ShiftChange) =>
                row.date
                  ? moment(row.date).format('DD.MM.YYYY')
                  : row.start
                    ? moment(row.start).format('DD.MM.YYYY')
                    : ''
              }
            />
            <Column
              columnKey="workdayStart"
              field="workdayStart"
              header="Начало смены"
            />
            <Column
              columnKey="workdayDuration"
              field="workdayDuration"
              header="Продолжительность"
            />
            <Column
              columnKey="breakDuration"
              field="breakDuration"
              header="Перерыв"
            />
          </DataTable>
        </div>
      )}

      {rowData.actionType === ActionTypeEnum.UPDATE &&
        updatedItems.length > 0 && (
        <div>
          <h5 className="pl-2">{actionLabel} смены</h5>
          <DataTable
            dataKey="id"
            value={updatedItems}
            className="w-full mt-2 mb-4"
          >
            <Column
              columnKey="date"
              header="Дата"
              body={(row: {
                  id: number;
                  old: ShiftChange;
                  new: ShiftChange;
                }) => {
                const oldDate = row.old.date
                  ? moment(row.old.date).format('DD.MM.YYYY')
                  : row.old.start
                    ? moment(row.old.start).format('DD.MM.YYYY')
                    : '';
                const newDate = row.new.date
                  ? moment(row.new.date).format('DD.MM.YYYY')
                  : row.new.start
                    ? moment(row.new.start).format('DD.MM.YYYY')
                    : '';
                const changed = oldDate && newDate && oldDate !== newDate;
                return (
                  <span>
                    {changed ? (
                      <>
                        {oldDate}
                        <i
                          className="pi pi-arrow-right"
                          style={{ margin: '0 0.5rem' }}
                        ></i>
                        {newDate}
                      </>
                    ) : (
                      newDate || oldDate || ''
                    )}
                  </span>
                );
              }}
            />
            <Column
              columnKey="workdayStart"
              header="Начало смены"
              body={(row: {
                  id: number;
                  old: ShiftChange;
                  new: ShiftChange;
                }) => {
                const oldValue = row.old.workdayStart || '';
                const newValue = row.new.workdayStart || '';
                const changed =
                    newValue && oldValue && oldValue !== newValue;
                return (
                  <span>
                    {changed ? (
                      <>
                        {oldValue}
                        <i
                          className="pi pi-arrow-right"
                          style={{ margin: '0 0.5rem' }}
                        ></i>
                        {newValue}
                      </>
                    ) : (
                      newValue || oldValue || ''
                    )}
                  </span>
                );
              }}
            />
            <Column
              columnKey="workdayDuration"
              header="Продолжительность"
              body={(row: {
                  id: number;
                  old: ShiftChange;
                  new: ShiftChange;
                }) => {
                const oldValue = row.old.workdayDuration || '';
                const newValue = row.new.workdayDuration || '';
                const changed =
                    newValue && oldValue && oldValue !== newValue;
                return (
                  <span>
                    {changed ? (
                      <>
                        {oldValue}
                        <i
                          className="pi pi-arrow-right"
                          style={{ margin: '0 0.5rem' }}
                        ></i>
                        {newValue}
                      </>
                    ) : (
                      newValue || oldValue || ''
                    )}
                  </span>
                );
              }}
            />
            <Column
              columnKey="breakDuration"
              header="Перерыв"
              body={(row: {
                  id: number;
                  old: ShiftChange;
                  new: ShiftChange;
                }) => {
                const oldValue = row.old.breakDuration || '';
                const newValue = row.new.breakDuration || '';
                const changed =
                    newValue && oldValue && oldValue !== newValue;
                return (
                  <span>
                    {changed ? (
                      <>
                        {oldValue}
                        <i
                          className="pi pi-arrow-right"
                          style={{ margin: '0 0.5rem' }}
                        ></i>
                        {newValue}
                      </>
                    ) : (
                      newValue || oldValue || ''
                    )}
                  </span>
                );
              }}
            />
          </DataTable>
        </div>
      )}
    </div>
  );
};
